import { render, staticRenderFns } from "./StaffFaqLine.vue?vue&type=template&id=3684bfd6&scoped=true&"
import script from "./StaffFaqLine.vue?vue&type=script&lang=js&"
export * from "./StaffFaqLine.vue?vue&type=script&lang=js&"
import style0 from "./StaffFaqLine.vue?vue&type=style&index=0&id=3684bfd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684bfd6",
  null
  
)

export default component.exports